import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Pill from '../pill/Pill';
import CTAButton from '../ctaButton/CTAButton';

const parseContent = ({ text, markdownText }) => {
  return text ? `<p>${text}</p>` : markdownText;
};

const IconBlock = ({
  data,
  direction,
  alignment,
  alignmentDesktop,
  alignItems,
  titleSize = 'large',
  iconSize,
  colourScheme,
  compact
}) => {
  const componentClasses = classNames('icon-block', {
    [`icon-block--${direction}`]: direction,
    [`icon-block--align-${alignment}`]: alignment,
    [`icon-block--align-desktop-${alignmentDesktop}`]: alignmentDesktop,
    [`icon-block--align-items-${alignItems}`]: alignItems,
    [`icon-block--title-${titleSize}`]: titleSize,
    [`icon-block--${iconSize}`]: iconSize,
    [`icon-block--${colourScheme}`]: colourScheme,
    'icon-block--compact': compact
  });

  return (
    <div className={componentClasses}>
      {data.stat ? (
        <h2 className="icon-block__stat">{data.stat}</h2>
      ) : (
        <img
          className={data.img?.roundedCorners && 'icon-block__img--rounded-corners'}
          src={data.img?.src}
          alt={data.img?.alt}
          aria-hidden="true"
          role={data.img?.role}
        />
      )}
      {data.title && (
        <h3>
          {data.title}
          {data.new && <Pill text="new" />}
        </h3>
      )}
      {data.text || data.markdownText ? (
        <div className="icon-block__content" dangerouslySetInnerHTML={{ __html: parseContent(data) }} />
      ) : null}
      {data.callToAction && (
        <div className="icon-block__ctas">
          {data.callToAction.map((cta) => (
            <CTAButton key={`${cta.link} - ${cta.text}`} className={cta.className} link={cta.link} text={cta.text} />
          ))}
        </div>
      )}
    </div>
  );
};

IconBlock.propTypes = {
  data: PropTypes.object,
  direction: PropTypes.oneOf(['horizontal']),
  alignment: PropTypes.oneOf(['left', 'center']),
  alignmentDesktop: PropTypes.oneOf(['center']),
  alignItems: PropTypes.oneOf(['top']),
  titleSize: PropTypes.oneOf(['medium', 'large']),
  iconSize: PropTypes.oneOf(['medium', 'large', 'x-large']),
  colourScheme: PropTypes.oneOf(['dark-navy']),
  compact: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default IconBlock;
